import React, { useState } from "react";
import { FaMapMarkerAlt, FaRegEnvelopeOpen } from "react-icons/fa";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import axios from "../axios/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const res = await axios.post("/contactus", formData);
      // console.log("Success:", res.data); // <-- Add this
      toast.success("Data Submitted successfully!");
      // alert("Message sent successfully!");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.log("Error sending message:", error); // <-- And this
      toast.error("Failed to send message.");
    }
  };

  const contactusCards = [
    {
      icon: <FaMapMarkerAlt color="#343F5A" />,
      title: "Reach Us",
      desc: "Taloja Navi Mumbai Maharashtra India",
    },
    {
      icon: <FaRegEnvelopeOpen color="#343F5A" />,
      title: "Mail Us",
      desc: "info@captureedits.com",
    },
  ];

  return (
    <>
      <Navbar />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="container my-5">
        <h3 className="amaranth-regular text_maincolor fw-bold text-center mb-4">
          Need Support ? Connect !!
        </h3>
        <div className="row justify-content-center">
          {contactusCards.map((val, index) => (
            <div key={index} className="col-md-4 pb-5">
              <div className="contactus_card p-3">
                <h2 className="fw-600">{val.icon}</h2>
                <h4 className="fw-500 my-3 text_maincolor fw-600">
                  {val.title}
                </h4>
                <p className="text-center fs-15">{val.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 container">
            <h3 className="text_maincolor amaranth-regular fw-bold mb-4">
              Connect With Us!!
            </h3>
            <div className="mt-2">
              <label className="mb-1 fw-bold">Name</label>
              <input
                className="form-control shadow-none"
                placeholder="Name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className="mt-4">
              <label className="mb-1 fw-bold">Email</label>
              <input
                className="form-control shadow-none"
                placeholder="Email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="mt-4">
              <label className="mb-1 fw-bold">Subject</label>
              <input
                className="form-control shadow-none"
                placeholder="Subject"
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>
            <div className="mt-4">
              <label className="mb-1 fw-bold">Message</label>
              <textarea
                placeholder="Message"
                className="form-control shadow-none"
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <div className="mt-4">
              <button
                className="btn bg_maincolor text-white"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
